import { createSelector } from 'reselect';

const selectSearch = state => state.search;

export const selectSearchInput = createSelector(
    [selectSearch],
    search => search.searchInput
)

export const selectSearchResult = createSelector(
    [selectSearch],
    search => search.searchResult
)

export const selectSearchResultSorted = createSelector(
    [selectSearch],
    search => search.searchResultSorted
)

export const selectSearchResultSortedArray = createSelector(
    [selectSearch],
    search => Object.keys(search.searchResultSorted).map(key => search.searchResultSorted[key]) 
)

export const selectLoadingSearch = createSelector(
    [selectSearch],
    search => search.loadingSearch
)

export const selectWordResults = createSelector(
    [selectSearch],
    search => search.searchResultSorted.wordDocs
)

export const selectPptResults = createSelector(
    [selectSearch],
    search => search.searchResultSorted.pptDocs
)

export const selectExcelResults = createSelector(
    [selectSearch],
    search => search.searchResultSorted.excelDocs
)

export const selectProjectResults = createSelector(
    [selectSearch],
    search => search.searchResultSorted.projects
)

export const selectTaskResults = createSelector(
    [selectSearch],
    search => search.searchResultSorted.tasks
)
